






















import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import { Storage } from 'aws-amplify';

@Component
export default class StorageImage extends Vue {

    @Prop()
    path!: string;

    @Prop()
    width!: number;

    @Prop()
    minWidth!: number;

    @Prop()
    maxWidth!: number;

    @Prop()
    height!: number;

    @Prop()
    minHeight!: number;

    @Prop()
    maxHeight!: number;

    private imageUrl = null;

    get cdnPath() {
        return `${process.env.VUE_APP_CHOICE_CDN}/${this.path}`
    }
    
    mounted() {
        if (this.path) {
            this.getImageUrl(this.path)
        }
        
    }

    @Watch('path')
    private async getImageUrl(key) {
        this.imageUrl = await Storage.get(key);
    }

}
